import background from "./background";

export default class Text extends background {
    text;
    fontSize;
    minFontSize;
    textColor;
    fontFace;
    textCenterAlign;

    constructor(properties) {
        super(properties);
        this.text = properties.text;
        this.textColor = Object.assign(
            {r: 255, g: 255, b: 255, a: 1.0},
            properties.textColor
        );
        this.fontFace = properties.fontFamily || global_font_family;
        this.textCenterAlign = true;
        this.minFontSize = 10;
        this.fontSize = properties.fontSize || 24;
    }

    changeTextColor(fontColor) {
        this.textColor = fontColor || this.textColor;
    }

    changeFontFamily(fontFace) {
        this.fontFace = fontFace || this.fontFace;
    }

    changeFontSize(fontSize) {
        this.fontSize = fontSize || this.fontSize;
    }

    decrementFontSize() {
        if (this.fontSize <= this.minFontSize) {
            this.fontSize = this.minFontSize;
            return;
        }

        this.fontSize--;
    }

    changeText(text) {
        this.text = text || this.text;
    }

    updateTextProperties(text, textColor, fontFace, fontSize) {
        this.changeText(text);
        this.changeTextColor(textColor);
        this.changeFontFamily(fontFace);
        this.changeFontSize(fontSize);
    }
}